/**
 * Evidence document pane for View Evidence (PDF, structured JSON, or text).
 */

import { SpinningLoader } from "risa-oasis-ui_v2";
import PdfRender from "../../../components/pdfRender/pdfRender";
import { PlainTextEvidencePanel } from "./PlainTextEvidencePanel";
import { StructuredEvidencePanel } from "./StructuredEvidencePanel";
import { useEvidenceSource } from "./hooks/useEvidenceSource";

/** Props for one evidence document pane. */
export interface EvidencePdfViewerProps {
  sourcePath: string;
}

/**
 * Resolve a relative eligibility path and render its PDF, structured data, or text.
 *
 * @param props - Authenticated relative evidence path
 * @returns Evidence viewer with loading and error states
 */
export function EvidencePdfViewer({ sourcePath }: EvidencePdfViewerProps) {
  const { pdfUrl, structuredDocument, textDocument, loading, error } =
    useEvidenceSource(sourcePath);

  return (
    <div className="doc-viewer-modal--container h-full min-h-0 w-full overflow-hidden">
      {loading && (
        <div className="flex h-full items-center justify-center gap-2 text-sm text-primaryGray-4">
          <SpinningLoader />
          Loading document…
        </div>
      )}
      {!loading && error && (
        <div className="flex h-full items-center justify-center px-4 text-center text-sm text-red-600">
          {error}
        </div>
      )}
      {!loading && !error && pdfUrl && <PdfRender file={pdfUrl} />}
      {!loading && !error && structuredDocument && (
        <StructuredEvidencePanel document={structuredDocument} />
      )}
      {!loading && !error && textDocument && (
        <PlainTextEvidencePanel text={textDocument} />
      )}
    </div>
  );
}
